import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { post } from '../utils/api';
import config from '../config';
import { useToast } from './ToastContext';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);

  const handleSendOtp = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
      await post('/auth/forgot-password', { email });
      setOtpSent(true);
      showToast('An OTP has been sent to your email address.', 'success');
    } catch (error) {
      setError(error.message || 'Failed to send OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
      await post('/auth/reset-password', { email, otp, password });
      showToast('Password reset successful. You can now log in with your new password.', 'success');
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      setError(error.message || 'Failed to reset password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="med-forgot-password-wrapper">
      <div className="med-forgot-password-card">
        <div className="med-left">
          <div className="med-left-content">
            <div className="med-logo">
              <div className="pill"></div>
              <h5>{config.appName}</h5>
            </div>
            <p className="med-tagline">
              Reset Your Password and Regain Access to Your Health Records.
            </p>
          </div>
        </div>
        <div className="med-right">
          <div className="med-form">
            <h3>Forgot Password</h3>
            <p className="subtitle">
              {otpSent
                ? 'Enter the OTP and your new password.'
                : 'Enter your email to receive an OTP.'}
            </p>

            {error && <Alert variant="danger">{error}</Alert>}

            {!otpSent ? (
              <Form onSubmit={handleSendOtp}>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={loading}
                  />
                </Form.Group>

                <Button className="reset-btn" type="submit" disabled={loading}>
                  {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Send OTP'}
                </Button>
              </Form>
            ) : (
              <Form onSubmit={handleResetPassword}>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>OTP</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter the OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    required
                    disabled={loading}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>New Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter your new password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={loading}
                  />
                </Form.Group>

                <Button className="reset-btn" type="submit" disabled={loading}>
                  {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Reset Password'}
                </Button>
              </Form>
            ) }

            <p className="login-link">
              Remember your password? <Link to="/login">Log In</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;